import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M12 4.972L20.252 19H3.748L12 4.972V4.972ZM12 3L2 20H22L12 3Z" fill="currentColor" />
    <path
      d="M12 15C11.448 15 11 14.549 11 13.993V10.007C11 9.451 11.448 9 12 9C12.552 9 13 9.451 13 10.007V13.994C13 14.549 12.552 15 12 15Z"
      fill="currentColor"
    />
    <path
      d="M13 17C13 17.552 12.552 18 12 18C11.448 18 11 17.552 11 17C11 16.448 11.448 16 12 16C12.552 16 13 16.448 13 17Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'ExclamationMarkTriangle');

export default Icon;
